import { render, staticRenderFns } from "./ReceiptAddNewGroup.vue?vue&type=template&id=abf95eb8&"
import script from "./ReceiptAddNewGroup.vue?vue&type=script&lang=js&"
export * from "./ReceiptAddNewGroup.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptAddNewGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports